import styles from './Dropdown.module.scss';
import ValidationIcons from '../ValidationIcons/ValidationIcons';
import CustomSelect, { type ICustomSelect } from './CustomSelect/CustomSelect';
import { type IOption } from '../shared/models/IOption';
import ErrorMessage from '../ErrorMessage/ErrorMessage';
import AssistiveText from '../AssistiveText/AssistiveText';

export interface IDropdown {
  options: IOption[];
  onChange?: (value: IOption) => void;
  id: string;
  label: string;
  inlineLabel?: boolean;
  placeholder?: string;
  disabled?: boolean;
  isValid?: boolean;
  errorMessage?: string;
  assistiveText?: string;
  defaultOption?: IOption;
  value?: string;
}

export default function Dropdown({
  options,
  onChange,
  id,
  label,
  inlineLabel = false,
  placeholder,
  disabled = false,
  isValid,
  errorMessage,
  assistiveText,
  defaultOption,
  value
}: IDropdown) {
  const CustomSelectProps: ICustomSelect = {
    options,
    onChange,
    id,
    placeholder,
    disabled,
    isValid,
    defaultOption,
    value
  };

  return (
    <div className={[styles.dropdown, inlineLabel ? styles.row : styles.column].join(' ')}>
      <label id={`${id}-label`} htmlFor={`${id}-button`}>
        {label}
      </label>
      <div className={styles.customSelectContainer}>
        <div className={styles.customSelectInnerContainer}>
        <CustomSelect {...CustomSelectProps} />
          <ValidationIcons isValid={isValid} />
        </div>
        <ErrorMessage isValid={isValid}>{errorMessage}</ErrorMessage>
        <AssistiveText>{assistiveText}</AssistiveText>
      </div>
    </div>
  );
}
